module.exports = __webpack_public_path__ + "img/chanpin1.a9b37c3a.png";